import { render, staticRenderFns } from "./EditPostAnswer.vue?vue&type=template&id=6efe60e3&scoped=true"
import script from "./EditPostAnswer.vue?vue&type=script&lang=js"
export * from "./EditPostAnswer.vue?vue&type=script&lang=js"
import style0 from "./EditPostAnswer.vue?vue&type=style&index=0&id=6efe60e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe60e3",
  null
  
)

export default component.exports